import React from "react";
import AllTerms from "./TermsModule/AllTerms";

const Terms = () => {
  return (
    <div>
      <AllTerms />
    </div>
  );
};

export default Terms;
